import api from 'api';

export function saveSensors(id, sensors) {
  return api.post(`/robot/${id}/sensors`, { sensors });
}

export function saveRobotSensorConfiguration(id, sensors, xmlSensors) {
  return api.post(`/robot/${id}/sensors`, { sensors, xmlSensors });
}
